export default __webpack_public_path__ + "static/media/logo.1d9675f9.png";